module.exports = __webpack_public_path__ + "Simple-Line-Icons.596814caa4fbaecbf501.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons/fonts/Simple-Line-Icons.ttf
// module id = ../../../../../src/assets/fonts/line-icons/fonts/Simple-Line-Icons.ttf
// module chunks = styles